var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EBEDFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_4472",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_4472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 25.5C14.3103 25.5 12.9296 25.2575 11.8577 24.7725C10.7859 24.2875 10.25 23.6614 10.25 22.8943C10.25 22.5391 10.3837 22.2051 10.651 21.8923C10.9183 21.5794 11.2879 21.3108 11.7598 21.0865L12.9405 22.1578C12.7263 22.2436 12.5012 22.3506 12.2652 22.4788C12.0294 22.6071 11.8679 22.7423 11.7808 22.8845C11.9461 23.1833 12.4381 23.4439 13.2567 23.6663C14.0752 23.8888 14.9881 24 15.9953 24C17.0023 24 17.9192 23.8888 18.7462 23.6663C19.5731 23.4439 20.0693 23.1833 20.2348 22.8845C20.1501 22.732 19.9793 22.5917 19.7223 22.4635C19.4651 22.3353 19.2212 22.2283 18.9905 22.1423L20.1557 21.0557C20.6672 21.2904 21.0608 21.5642 21.3365 21.877C21.6122 22.1898 21.75 22.5275 21.75 22.89C21.75 23.6585 21.2141 24.2856 20.1423 24.7712C19.0704 25.2571 17.6897 25.5 16 25.5ZM16.025 20.625C17.6813 19.3698 18.9246 18.1266 19.7548 16.8953C20.5849 15.6638 21 14.441 21 13.227C21 11.5015 20.4599 10.199 19.3798 9.3195C18.2996 8.43983 17.1746 8 16.0048 8C14.8349 8 13.7083 8.44008 12.625 9.32025C11.5417 10.2003 11 11.5034 11 13.2298C11 14.3638 11.4099 15.5398 12.2298 16.7578C13.0496 17.9758 14.3147 19.2648 16.025 20.625ZM16 22.5C13.8178 20.8685 12.189 19.284 11.1135 17.7465C10.0378 16.2092 9.5 14.7032 9.5 13.2285C9.5 12.1147 9.6965 11.1392 10.0895 10.302C10.4825 9.46483 10.9898 8.76383 11.6115 8.199C12.2333 7.63433 12.931 7.21 13.7045 6.926C14.4778 6.642 15.2435 6.5 16.0015 6.5C16.7595 6.5 17.5247 6.642 18.297 6.926C19.0695 7.21 19.7667 7.63433 20.3885 8.199C21.0102 8.76383 21.5175 9.46508 21.9105 10.3027C22.3035 11.1404 22.5 12.1152 22.5 13.227C22.5 14.7018 21.9622 16.2081 20.8865 17.7457C19.811 19.2834 18.1822 20.8682 16 22.5ZM16.0048 14.8943C16.5003 14.8943 16.9246 14.7193 17.2777 14.3693C17.6311 14.0193 17.8077 13.5933 17.8077 13.0913C17.8077 12.5894 17.6307 12.1619 17.2768 11.8087C16.9227 11.4554 16.4972 11.2788 16 11.2788C15.5077 11.2788 15.0833 11.4558 14.727 11.8098C14.3705 12.1639 14.1923 12.5895 14.1923 13.0865C14.1923 13.5917 14.3705 14.0193 14.727 14.3693C15.0833 14.7193 15.5093 14.8943 16.0048 14.8943Z",
    fill: "#384BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d887ce4b3eef25a81d895e028c36c50a.svg";
export { ForwardRef as ReactComponent };